
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './src/locales/en';
import { tr } from './src/locales/tr';
import { sq } from './src/locales/sq';
import { ko } from './src/locales/ko';
import { fr } from './src/locales/fr';
import { de } from './src/locales/de';
import { it } from './src/locales/it';
import { pl } from './src/locales/pl';
import { id } from './src/locales/id';
import { fil } from './src/locales/fil';

export const resources = {
  en,
  tr,
  sq,
  ko,
  fr,
  de,
  it,
  pl,
  id,
  fil
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr', // Uygulama varsayılan dili Türkçe olarak sabitlendi
    supportedLngs: ['en', 'tr', 'sq', 'ko', 'fr', 'de', 'it', 'pl', 'id', 'fil'], // Explicitly declare supported languages
    nonExplicitSupportedLngs: true, // Enables en-US, en-GB -> en mapping
    fallbackLng: 'tr', // Eksik çeviri anahtarlarında Türkçe'ye düş
    interpolation: {
      escapeValue: false
    }
  });

// Handle Turkish 'i' vs English 'I' via html lang attribute
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
